module.exports = __webpack_public_path__ + "static/media/footer-bg.d465266a.svg";